/**
 * Executes function if user clicks outside the popover or one of its children
 */

import { useEffect } from 'react';
export const useOnOutsidePopoverMouseDown = (onOutsideMouseDown, popover, referenceElement, activePopovers, id) => {
  useEffect(() => {
    const onMouseDown = event => {
      if (popover && !popover.contains(event.target)) {
        // This click didn't land in our main popover
        let childClicked = false;

        // If it landed on the element that opened the popover, don't trigger close
        if (referenceElement?.contains(event.target)) {
          childClicked = true;
        }
        if (activePopovers && id !== undefined) {
          const groupDetails = activePopovers.get(id);

          // Otherwise see if the click landed inside any child popovers
          if (!childClicked && groupDetails) {
            // Get a list of any popovers with the same group but higher level, these are child popovers
            const childPopovers = Array.from(activePopovers.values()).filter(comparePopover => {
              return comparePopover.group === groupDetails.group && comparePopover.level > groupDetails.level;
            });

            // See if the click fell inside any of the children we found
            childPopovers?.forEach(child => {
              if (child.popoverElement.contains(event.target)) {
                childClicked = true;
                return;
              }
            });
          }
        }

        // if click wasn't in our popover or one of its children trigger close action
        !childClicked && onOutsideMouseDown?.();
      }
    };
    window.addEventListener('mousedown', onMouseDown);
    return () => {
      window.removeEventListener('mousedown', onMouseDown);
    };
  }, [onOutsideMouseDown, popover, referenceElement, activePopovers, id]);
};
//# sourceMappingURL=useOnOutsidePopoverMouseDown.js.map